module.exports = __webpack_public_path__ + "static/extension-manager-0f1ddf09ec4234f76b82a4ce29bc0e7a.png";